/* El backend manda el Content-Disposition con las dos formas del nombre:

       attachment; filename=Informe_x.xlsx; filename*=UTF-8''Informe_x.xlsx

   Un `filename="?(.+)"?` es codicioso y se traga tambien el segundo parametro,
   asi que el navegador acaba guardando "Informe_x.xlsx; filename_=UTF-8''..."
   (el * no es valido en un nombre de fichero y lo sustituye por _). Se corta en
   el ';' y se prioriza filename* porque es el que conserva las tildes. */
export const nombreFicheroDescarga = (contentDisposition, porDefecto) => {
    if (!contentDisposition) return porDefecto;

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        try {
            return decodeURIComponent(utf8Match[1].trim());
        } catch {
            return utf8Match[1].trim();
        }
    }

    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
    return fileNameMatch && fileNameMatch[1]
        ? fileNameMatch[1].trim()
        : porDefecto;
};
